import { render, staticRenderFns } from "./editComment.vue?vue&type=template&id=2b080b2f&scoped=true"
import script from "./editComment.vue?vue&type=script&lang=js"
export * from "./editComment.vue?vue&type=script&lang=js"
import style0 from "./editComment.vue?vue&type=style&index=0&id=2b080b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b080b2f",
  null
  
)

export default component.exports